export const SIGNUP_VARIANTS = {
  DEFAULT: 'DEFAULT',
  CONFIRM_EMAIL: 'CONFIRM_EMAIL',
  CONFIRM_EMAIL_V2: 'CONFIRM_EMAIL_V2',
  CLAIM_PROFILE: 'CLAIM_PROFILE',
};

export default {
  SIGNUP_VARIANTS,
};
